import { AnimatedSection } from '@components/animated'
import { ArrowRight, FileCheck } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { ApplicationDetail } from 'types/api'

import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'

export function ApplicationsWidget(props: { application?: ApplicationDetail }) {
  const { t } = useTranslation('offers')

  if (!props.application) return null

  const isActive = !!props.application.status

  return (
    <AnimatedSection>
      <Card className="mb-6 flex flex-col gap-4 p-4 sm:flex-row sm:items-center sm:justify-between sm:p-5">
        <div className="flex items-center gap-3.5">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary">
            <FileCheck className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <div className="font-display text-base font-bold leading-tight text-ink">
              {t('myApplication')}
            </div>
            <div className="mt-0.5 flex items-center gap-1.5 text-sm text-muted-foreground">
              <span
                className={`inline-block h-2 w-2 rounded-full ${
                  isActive ? 'bg-primary' : 'bg-ink/25'
                }`}
              />
              {isActive
                ? t('application_active', { defaultValue: 'Aktívna' })
                : t('application_not_activated')}
            </div>
          </div>
        </div>
        <Button asChild variant="ghostDark" className="shrink-0">
          <Link to="/user/application">
            {t('application')}
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
      </Card>
    </AnimatedSection>
  )
}
